import { render } from "./ctx-dog-orgs.vue?vue&type=template&id=aa0f48e4&scoped=true"
import script from "./ctx-dog-orgs.vue?vue&type=script&setup=true&lang=js"
export * from "./ctx-dog-orgs.vue?vue&type=script&setup=true&lang=js"

import "./ctx-dog-orgs.vue?vue&type=style&index=0&id=aa0f48e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0f48e4"],['__file',"src/views/history/history-card/components/ctx-dog-orgs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa0f48e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa0f48e4', __exports__)) {
    api.reload('aa0f48e4', __exports__)
  }
  
  module.hot.accept("./ctx-dog-orgs.vue?vue&type=template&id=aa0f48e4&scoped=true", () => {
    api.rerender('aa0f48e4', render)
  })

}


export default __exports__